export const DialogQcFieldName = 'dialogQcFieldComponent';
